module.exports = __webpack_public_path__ + "img/palau.b805f38a.svg";